<template>
    <div
            class="modal fade"
            id="sys_completetask_modal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="myModalLabel"
            aria-hidden="true"
    >
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                    <h4 class="modal-title" id="myModalLabel">完成查表</h4>
                </div>
                <!-- modal-body-->
                <div class="modal-body">
                    <div class="panel-body">
                        <div class="form-group" v-for="(item,index) in submitData" :key="index">
                            <label class="col-sm-2 control-label">电表读数:</label>
                            <div class="col-sm-4">
                                <input type="text" class="form-control" v-model="item.amount"/>
                                <input type="hidden" v-model="item.id"/>
                            </div>
                            <label class="col-sm-2 control-label">电表照片 :</label>
                            <div class="col-sm-4">
                                <input
                                        type="file"
                                        class="form-control"
                                        :id="gernerateId(index)"
                                        @change="changeImg(index)"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <!-- modal-footer -->
                <div class="modal-footer">
                    <button type="button" data-dismiss="modal" class="btn btn-default">关闭</button>
                    <button type="button" class="btn btn-primary" @click="submit">确定</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  // /ammeter/(ammeter_id)/records/

  // amount (string) – 电表读数
  // file_path (string) – 照片存储路径
  // ammeter_id – 电表ID

  export default {
    data () {
      return {
        org_id: '', // 公司id
        ammeterlist: [], // 所有电表
        submitData: [] // 所有的电表上传数据
      }
    },
    props: ['infoStationid'],
    mounted: function () {
      var self = this
      var org_id = JSON.parse(localStorage.getItem('companyInfo')).id
      self.org_id = org_id
    },
    methods: {
      initFunc: function () {
        var self = this
        console.log('获取基站下所有电表')
        self.global.axiosGet(
          self,
          'station/' + self.infoStationid + '/ammeters/',
          function (res) {
            console.log(res)
            for (var i = 0; i < res.length; i++) {
              var ammeterInfo = {}
              ammeterInfo.ammeter_id = res[i].id
              ammeterInfo.amount = ''
              ammeterInfo.file_path = ''
              self.submitData.push(ammeterInfo)
            }
            console.log('submitData---', self.submitData)
          }
        )
      },
      // 拼接id
      gernerateId: function (index) {
        return 'upload_' + index
      },
      // 选择图片
      changeImg: function (index) {
        console.log(index)
        // 上传返回file_path;
        var self = this
        self.global.uploadfile(
          self,
          'upload_' + index,
          function (res) {
            console.log(res)
            if (res.status == 'success') {
              self.submitData[index].file_path = res.file_path
            } else {
              alert('图片上传失败')
            }
          },
          function () {
            alert('图片上传失败')
          }
        )
      },
      // 提交
      submit: function () {
        console.log(this.submitData)
        var self = this
        // ammeter/(ammeter_id)/records/
        var index = 0
        for (var i = 0; i < self.submitData.length; i++) {
          self.global.axiosPost(
            self,
            'ammeter/' + self.submitData[i].ammeter_id + '/records/',
            self.submitData[i],
            function (res) {
              index++
              if (index == self.submitData.length) {
                alert('上传完成')
                $('#ammetertask_atptable').bootstrapTable('refresh')
              }
            },
            function (res) {
              console.log('error', res)
            }
          )
        }
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/lookammetertask/ammeterrecord.vue